import React from 'react';
export function UrgencySection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-[#1a2e1a] to-[#142014] text-center" data-id="element-153">
      <div className="max-w-3xl mx-auto" data-id="element-154">
        <div className="text-6xl mb-8" data-id="element-155">⚡</div>

        <div className="font-heading text-3xl md:text-5xl font-black space-y-4 mb-12" data-id="element-156">
          <p className="text-[#a8c5a8]" data-id="element-157">No es el rival.</p>
          <p className="text-[#a8c5a8]" data-id="element-158">No es tu equipo.</p>
          <p className="text-[#c8e6c9] text-4xl md:text-6xl mt-8" data-id="element-159">
            👉 Sos vos… entrenando mal.
          </p>
        </div>

        <div className="bg-red-900/20 border border-red-500/30 rounded-2xl p-8 inline-block" data-id="element-160">
          <p className="text-xl md:text-2xl font-bold text-red-400 flex items-center justify-center gap-3" data-id="element-161">
            <span className="text-3xl" data-id="element-162">🔥</span>
            Si te cansaste de sentir que estás siempre un paso atrás…
          </p>
        </div>
      </div>
    </section>;
}